import React, {useContext, useEffect} from 'react'
import Layout from '../../../components/layout/layout'
import '../mlOutRails/mlOutRails.scss'
import digitalHealthImage from '../../../images/machine-learning-healthcare.jpg'
import { LanguageContext } from '../../../components/LanguageSwitcher/LanguageContext'
import { ArticleBackLink, ArticleNextCta } from '../../../components/ArticleNav/ArticleNav'
import ArticleCta from '../../../components/ArticleCta/ArticleCta'
import ArticleListen from '../../../components/ArticleListen/ArticleListen'
import ArticleSummary from '../../../components/ArticleSummary/ArticleSummary'
import Seo, { articleJsonLd, articleBreadcrumbs } from '../../../components/Seo/Seo'


const DigitalHealth = () => {
  const { translations } = useContext(LanguageContext);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Layout>
      <Seo
        title='Digital Health Platforms and Medical Tourism'
        description={translations.BlogDigitalHealth1}
        type='article'
        image={digitalHealthImage}
        jsonLd={[
          articleJsonLd({ headline: translations.BlogDigitalHealth, description: translations.BlogDigitalHealth1, datePublished: '2026-06-02', author: translations.BlogDigitalHealth12 }),
          articleBreadcrumbs(translations.BlogDigitalHealth, '/articles/digitalHealth'),
        ]}
      />
      <div className='mlrole-health-container'>

        <div className='mlrole-health healthh-box'>
          <ArticleBackLink />
          <h1 className='article-main-title'>{translations.BlogDigitalHealth}</h1>
          <div className='article-author-head-container'>
            <div className='article-author-head'>
              <p>{translations.BlogDigitalHealth11}</p>
              <p>•</p>
              <p>{translations.BlogDigitalHealth12}</p>
            </div>
            <p className='article-author-head'>{translations.BlogDigitalHealth13}</p>
          </div>

          <div className='mlrole-health-first-image-box'>
            <img src={digitalHealthImage} alt='digital health platforms' className='mlrole-health-first-image' />
          </div>
          <ArticleListen />
          <ArticleSummary id='digitalHealth' />
          <div className='mlrole-health-txt-container'>
            <div className='mlrole-health-txt-child-box'>
              <p>{translations.BlogDigitalHealth1}</p>
              <p>{translations.BlogDigitalHealth2}</p>

              <h2 className='article-secondaty-title'>{translations.BlogDigitalHealth3}</h2>
              <p>{translations.BlogDigitalHealth4}</p>
              <p>{translations.BlogDigitalHealth5}</p>

              <h2 className='article-secondaty-title'>{translations.BlogDigitalHealth6}</h2>
              <p>{translations.BlogDigitalHealth7}</p>
              <p>{translations.BlogDigitalHealth8}</p>
              <p>{translations.BlogDigitalHealth9}</p>
              <p>{translations.BlogDigitalHealth10}</p>
            </div>
          </div>

          <ArticleCta />
          <ArticleNextCta link='/articles/mlrolehealth' title={translations.BlogmlroleHealth} />
        </div>
      </div>
    </Layout>
  )
}

export default DigitalHealth
